/**
 * useBuildingLayers — Wrapper hook para edificios en el mapa
 *
 * @remarks
 * Lee visibilidad y filtros desde `useBuildingsLayerStore` para que UrbanTabbedPanel
 * pueda controlarlos sin prop-drilling. Solo activo cuando módulo es 'urban'.
 */

import { useProject } from '../../../projects';
import { useModuleStore } from '../../../module-store';
import { useBuildingsLayerStore } from '../../../buildings/buildings-layer-store';
import { useBuildingMapLayer } from './useBuildingMapLayer';

export function useBuildingLayers(): void {
  const { projectId }    = useProject();
  const { activeModule } = useModuleStore();
  const userVisible      = useBuildingsLayerStore((s) => s.visible);
  const filters          = useBuildingsLayerStore((s) => s.filters);

  const visible = activeModule === 'urban' && userVisible && Boolean(projectId);

  useBuildingMapLayer({
    projectId: projectId ?? '',
    visible,
    filters,
  });
}
